// tslint:disable:object-literal-sort-keys
import * as React from 'react';

const map = require('lodash/map');

import { ComponentClass } from 'react';
import { BedroomFilter } from '../../containers/filters/bedroom_filter';
import { CommercialPriceFilter, CommercialRentPriceFilter, PriceFilter } from '../../containers/filters/price_filter';
import { RoomsFilter, RoomsRentFilter } from '../../containers/filters/rooms_filter';
import { FlatSquareFilter, GroundSquareFilter } from '../../containers/filters/square_filter';
import { UserGeoFilter } from '../../containers/filters/user_geo_filter';
import { YearFilter } from '../../containers/filters/year_filter';
import { ISearchConfig } from '../../models/search';
import { FlatTypeFilter } from '../filters/flat_type_filter';
import { SuburbanOfferFilter } from '../filters/suburban_offer_filter';

const RoomFiltersSet = [ PriceFilter, UserGeoFilter ];
const SuburbanFiltersSet = [ SuburbanOfferFilter, PriceFilter, UserGeoFilter ];
const FlatFiltersSet = [ RoomsFilter, PriceFilter, UserGeoFilter ];
const FlatRentFiltersSet = [ RoomsRentFilter, PriceFilter, UserGeoFilter ];
const FlatSaleFiltersSet = [ FlatTypeFilter, RoomsFilter, PriceFilter, UserGeoFilter ];
const OfficeFiltersSet = [ CommercialPriceFilter, FlatSquareFilter, UserGeoFilter ];
const OfficeRentFiltersSet = [ CommercialRentPriceFilter, FlatSquareFilter, UserGeoFilter ];
const SectorFiltersSet = [ PriceFilter, GroundSquareFilter, UserGeoFilter ];
const SectorSuburbanFiltersSet = [ SuburbanOfferFilter, PriceFilter, GroundSquareFilter, UserGeoFilter ];
const HouseRentFilterSet = [ BedroomFilter, PriceFilter, UserGeoFilter ];
const NewBuildingsFilterSet = [ RoomsFilter, YearFilter, PriceFilter, UserGeoFilter ];

export const SearchConfig: ISearchConfig = {
  buy: {
    flat: FlatFiltersSet,
    secondary_flat: FlatFiltersSet,
    new_flat: FlatFiltersSet,

    room: RoomFiltersSet,
    part: RoomFiltersSet,
    house: SuburbanFiltersSet,
    housepart: SuburbanFiltersSet,
    townhouse: SuburbanFiltersSet,
    ready: RoomFiltersSet,
    garage: RoomFiltersSet,

    office: OfficeFiltersSet,
    trade_area: OfficeFiltersSet,
    warehouse: OfficeFiltersSet,
    psn: OfficeFiltersSet,
    fastfood: OfficeFiltersSet,
    enterprise: OfficeFiltersSet,
    auto: OfficeFiltersSet,
    building: OfficeFiltersSet,
    domestic: OfficeFiltersSet,

    sector: SectorSuburbanFiltersSet,
  },
  rent_long: {
    flat: FlatRentFiltersSet,

    room: RoomFiltersSet,
    bed: RoomFiltersSet,
    house: RoomFiltersSet,
    housepart: RoomFiltersSet,
    townhouse: RoomFiltersSet,
    garage: RoomFiltersSet,
    ready: RoomFiltersSet,

    office: OfficeRentFiltersSet,
    trade_area: OfficeRentFiltersSet,
    warehouse: OfficeRentFiltersSet,
    psn: OfficeRentFiltersSet,
    fastfood: OfficeRentFiltersSet,
    enterprise: OfficeRentFiltersSet,
    auto: OfficeRentFiltersSet,
    building: OfficeRentFiltersSet,
    domestic: OfficeRentFiltersSet,

    comsector: SectorFiltersSet,
  },
  rent_short: {
    flat: FlatRentFiltersSet,

    room: RoomFiltersSet,
    bed: RoomFiltersSet,

    houserent: HouseRentFilterSet,
  },
};

export const AbstractFlatSearchConfig: ISearchConfig = {
  ...SearchConfig,
  buy: {
    ...SearchConfig.buy,
    flat: FlatSaleFiltersSet,
    secondary_flat: FlatSaleFiltersSet,
    new_flat: FlatSaleFiltersSet,
  },
};

const filtersMap = (filtersSet: ComponentClass<{}>[]) => map(
  filtersSet,
  (element: ComponentClass<{}>, i: number) => React.createElement(element, { key: i }),
);

export const renderFilters = (
  searchType: string,
  buildingTypes: string[],
  isNew: boolean,
  searchConfig: ISearchConfig,
) => {
  if (isNew) {
    return filtersMap(NewBuildingsFilterSet);
  } else {
    const buildingType = buildingTypes.includes('sector') ? 'sector' : buildingTypes[0];

    return filtersMap(searchConfig[searchType][buildingType]) ;
  }
};
